import React from 'react';

import {
	ChevronThinRightIcon,
	ChevronThinLeftIcon,
	CustomFilterIcon,
} from 'components/icons';
import { chartDarkGray } from 'styles/colors';
import {
	Container,
	List,
	Row,
	BackRow,
	FiltersContainer,
	FilterLabel,
	FilterIconWrapper,
	FilterRow,
} from './CustomFilters.styles';
import { CustomFilterSelect } from 'SecondaryNav/CustomFilterSelect';
import { SmallButtonLink } from '../MoreFilters/MoreFilters.styles';
import { convertToArray } from 'Details/utils';

export class CustomFilters extends React.Component {
	render() {
		const {
			customFilters,
			customFiltersValues,
			clearAll,
			options,
			selectedFilter,
			selectFilter,
			closeFilter,
			onFilterChange,
			loading,
		} = this.props;
		const activeCustomFilters = options
			? options.filter(({ isActive }) => isActive)
			: [];
		const customFiltersArray = convertToArray(customFilters);

		return (
			<Container selectedFilter={!!selectedFilter}>
				{!selectedFilter && (
					<React.Fragment>
						<Row>
							<SmallButtonLink onClick={clearAll}>Clear all</SmallButtonLink>
						</Row>
						<List>
							{activeCustomFilters.map(filterData => (
								<FilterRow
									key={filterData.name}
									onClick={() => selectFilter(filterData)}
								>
									<FilterLabel
										active={
											customFiltersArray &&
											customFiltersArray.includes(filterData.name)
										}
									>
										{filterData.label}
									</FilterLabel>
									<FilterIconWrapper>
										{customFiltersArray &&
										customFiltersArray.includes(filterData.name) ? (
											<CustomFilterIcon
												color={chartDarkGray}
												width="24px"
												height="24px"
											/>
										) : (
											<ChevronThinRightIcon width="24px" height="24px" />
										)}
									</FilterIconWrapper>
								</FilterRow>
							))}
						</List>
					</React.Fragment>
				)}

				<FiltersContainer>
					{selectedFilter && (
						<React.Fragment>
							<BackRow onClick={closeFilter}>
								<FilterIconWrapper>
									<ChevronThinLeftIcon width="24px" height="24px" />
								</FilterIconWrapper>
								<FilterLabel>{selectedFilter.label}</FilterLabel>
							</BackRow>

							<CustomFilterSelect
								closeFilter={closeFilter}
								customFiltersValues={customFiltersValues}
								customFilters={customFilters}
								data={selectedFilter}
								onChange={onFilterChange}
								key={selectedFilter.name}
								loading={loading}
							/>
						</React.Fragment>
					)}
				</FiltersContainer>
			</Container>
		);
	}
}
